import { hot } from 'react-hot-loader/root';
import Component from './settings-view';

export default hot(Component);
